module.exports = __webpack_public_path__ + "static/2d_examplethumb-18612e58bb9d16fe7ae4da83f2a52aea.jpg";